import * as actionTypes from "../actionTypes";
const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.TOP_FIVE_PRODUCTS:
      return {
        ...state,
        allData: action?.payload?.data || [],
      };
    default:
      return state;
  }
};

export default reducer;

